export default __webpack_public_path__ + "static/media/DSC02229.f4d4b6ce.jpeg";